import { render, staticRenderFns } from "./ItemCardDescription.vue?vue&type=template&id=31fe2c47&scoped=true"
import script from "./ItemCardDescription.vue?vue&type=script&lang=ts"
export * from "./ItemCardDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fe2c47",
  null
  
)

export default component.exports